import * as angular from "angular";
import template from "./entity-schema-tab.html";
import "./entity-schema-tab.less";
import jsonSchemaForm from "../../../../../../extensions/json-schema/json-schema-form";
import type {
	JsonSchemaFormOptions,
	SchemaFormChangeHandler
} from "../../../../../../extensions/json-schema/json-schema-form";
import type { JsonSchemaDefinition } from "../../../../../../extensions/json-schema/schemaFormModel";

export class EntitySchemaTabController implements angular.IController {
	public subSchema?: JsonSchemaDefinition;
	public sectionKey?: string;
	public onChange?: SchemaFormChangeHandler;
	public schema?: JsonSchemaDefinition;
	public options?: JsonSchemaFormOptions;
	private isInitialized = false;

	public $onChanges(changes: angular.IOnChangesObject): void {
		const subSchema = changes.subSchema?.currentValue as JsonSchemaDefinition | undefined;
		if(this.isInitialized || !subSchema) {
			return;
		}

		this.isInitialized = true;
		this.schema = subSchema;
		this.options = this.onChange
			? { formDefaults: { onChange: this.onChange } }
			: undefined;
	}
}

export default angular.module("vesl.components.entity-schema-tab", [jsonSchemaForm])
	.component("entitySchemaTab", {
		controller: EntitySchemaTabController,
		template,
		bindings: {
			subSchema: "<",
			sectionKey: "<",
			model: "=",
			onChange: "<"
		}
	})
	.name;
